import React, { useRef, useState, useEffect, useCallback } from 'react';

const PhotoCarousel = ({ title, photos }) => {
  const trackRef = useRef(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);

  const updateEdges = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    setAtStart(el.scrollLeft <= 1);
    setAtEnd(Math.ceil(el.scrollLeft + el.clientWidth) >= el.scrollWidth - 1);
  }, []);

  useEffect(() => {
    const el = trackRef.current;
    if (!el) return;
    updateEdges();
    el.addEventListener('scroll', updateEdges, { passive: true });
    window.addEventListener('resize', updateEdges);
    return () => {
      el.removeEventListener('scroll', updateEdges);
      window.removeEventListener('resize', updateEdges);
    };
  }, [updateEdges]);

  const scrollByCard = (direction) => {
    const el = trackRef.current;
    if (!el) return;
    const card = el.querySelector('.photo-carousel-item');
    const step = card ? card.offsetWidth + 16 : el.clientWidth * 0.8;
    el.scrollBy({ left: direction * step, behavior: 'smooth' });
  };

  return (
    <section className="photo-carousel">
      {title && <h2 className="photo-carousel-title">{title}</h2>}

      <div className="photo-carousel-viewport">
        <ul className="photo-carousel-track" ref={trackRef}>
          {photos.map((photo) => (
            <li className="photo-carousel-item" key={photo.src}>
              <img src={photo.src} alt={photo.alt} loading="lazy" decoding="async" />
            </li>
          ))}
        </ul>

        <button
          type="button"
          className="photo-carousel-btn photo-carousel-btn--prev"
          onClick={() => scrollByCard(-1)}
          disabled={atStart}
          aria-label="Previous photos"
        />
        <button
          type="button"
          className="photo-carousel-btn photo-carousel-btn--next"
          onClick={() => scrollByCard(1)}
          disabled={atEnd}
          aria-label="Next photos"
        />
      </div>
    </section>
  );
};

export default PhotoCarousel;
